import { render } from "./page-search.vue?vue&type=template&id=445d7a29"
import script from "./page-search.js?vue&type=script&lang=js"
export * from "./page-search.js?vue&type=script&lang=js"

import "./page-search.vue?vue&type=style&index=0&id=445d7a29&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__